import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import ReactDatePicker from '../../../../_components/DatePicker/ReactDatePicker';
import moment from 'moment';

class AvailableOn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      placeholder: 'Available Now',
      sendOn: props.sendOn || '',
      sendLaterMin: '',
      sendLaterMax: '',
      noMinTime: props.noMinTime || false,
      noMaxTime: props.noMaxTime || false,
      apptDate: props.apptDate,
      apptType: props.apptType
    }

    this.setDefault = this.setDefault.bind(this);
    this.handleSendNow = this.handleSendNow.bind(this);
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.apptDate !== this.props.apptDate) || (prevProps.apptType !== this.props.apptType)) {
      this.setState({
        apptDate: this.props.apptDate,
        apptType: this.props.apptType
      }, () => {
        this.props.apptType === 'telehealth' ? this.setDefault() : this.handleSendNow();
      })
    }
  }

  handleSendNow() {
    this.props.setAvailableOn('');
    this.setState({
      sendOn: '',
      placeholder: 'Available Now'
    })
  }

  calculateMinDate() {
    return moment().add(1, 'days').toDate();
  }

  calculateMaxDate() {
    if (this.state.apptDate) {
      return this.state.apptDate;
      // const apptDate = moment(this.state.apptDate);

      // return apptDate.subtract(1, 'days').toDate();
    }
  }

  setDefault() {
    const apptDate = moment(this.state.apptDate);
    const today = moment().startOf("day");

    if (apptDate.isValid() && apptDate.diff(today, 'days') >= 2 && this.state.apptType === 'telehealth') {
      const dayBeforeAppt = apptDate.subtract(1, 'days').set('hour', 14).set('minute', 0).toDate();

      this.props.setAvailableOn(dayBeforeAppt);
      this.setState({ sendOn: dayBeforeAppt });
    } else {
      this.availableNow();
    }
  }

  availableNow() {
    this.props.setAvailableOn('');
    this.setState({
      placeholder: 'Available Now',
      sendOn: ''
    });
  }

  isDisabled() {
    if (this.state.apptDate) {
      const apptDate = moment(this.state.apptDate);
      const today = moment().startOf("day");

      return apptDate.diff(today, 'days') < 2;
    }

    return true;
  }

  render() {
    const popover = (
      <Popover>
        <Popover.Title as="h3">Available On</Popover.Title>
        <Popover.Content>
          <p>The appointment will be scheduled, but the patient will not be able to complete the questionnaire until the date and time entered. A notification will be sent out at the date and time entered.</p>
          <p>To allow the patient to complete the questionnaire <strong>immediately</strong>, leave "Available On" blank.</p>
        </Popover.Content>
      </Popover>
    )

    return <>
      <label>
        <span className="text-danger">*</span> Available On &nbsp;
        <OverlayTrigger trigger='click' placement='right' overlay={popover}>
          <i className="fa fa-question-circle" aria-hidden="true"></i>
        </OverlayTrigger>
      </label>
      <br />
      <ReactDatePicker
        disabled={this.isDisabled()}
        placeholderText={this.state.placeholder}
        minDate={this.calculateMinDate()}
        maxDate={this.calculateMaxDate()}
        minTime={this.state.noMinTime ? '' : moment().set('hours', 6).set('minute', 0).toDate()}
        maxTime={this.state.noMaxTime ? '' : moment().set('hours', 18).set('minute', 0).toDate()}
        showTimeSelect
        timeFormat="hh:mm aa"
        timeIntervals={15}
        dateFormat="MMM d, yyyy h:mm aa"
        selected={this.state.sendOn}
        onChange={(date) => {
          this.props.setAvailableOn(date);
          this.setState({ sendOn: date })
        }}
        className="form-control"
        wrapperClassName={this.props.width100 ? "w-100" : ""}
      />

      {this.state.sendOn &&
        <button onClick={this.handleSendNow} type="button" className="btn btn-link">Available Now</button>
      }
    </>;
  }
}

export default AvailableOn;